import { render, staticRenderFns } from "./RegistrationUser.vue?vue&type=template&id=1cd75b4d"
import script from "./RegistrationUser.vue?vue&type=script&lang=js"
export * from "./RegistrationUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports